import numeral from 'numeral';
import 'numeral/locales/es';

numeral.locale('en');

export const formatNumber = (price) => {
  return numeral(price).format('0,0.00');
};

export const showPrice = (price, currency = '$', format = '0,0.00') => {
  return price ? `${currency} ${formatNumber(price, format)}` : '-';
};

export const showValueWithCurrency = (price, currency = 'CUP', defaultValue = '', format = '0,0.00') => {
  return price ? `${formatNumber(price, format)} ${currency}` : defaultValue;
};

export const scrollToPosition = (value = 0) => {
  document.body.scrollTop = value; // For Safari
  document.documentElement.scrollTop = value;
};

export const getFileName = (value) => {
  if (!value) return '';
  const paths = value.split('/');
  return paths[paths.length - 1];
};

export const showCard = (value) => {
  return '**** **** **** ' + value.substr(-4);
};
